import React from 'react';
/**
 * Config for References Display.
 * @return {ReferencesLogic}
 */
function ReferencesLogic() {
  return (<h1>References</h1>

  );
}

export default ReferencesLogic;
